import { FC, Props } from "./typings";
import styles from "./styles.module.scss";
import sanitizeHtml from "sanitize-html";
import { cleanCompanyName } from "utils/cleanCompanyName";
import NipWithCopy from "../NipWithCopy";

const SellerCell: FC<Props> = ({ element }) => {
  return (
    <div className={styles.wrapper}>
      <div className={`${styles.stack}`}>
        <div
          dangerouslySetInnerHTML={{
            __html: sanitizeHtml(cleanCompanyName(element.Seller?.Name)),
          }}
          className={styles.sender}
        ></div>
        {/* Drugi wiersz: NIP sprzedawcy (maska + kopiuj na hover). */}
        <NipWithCopy nip={element.Seller?.Nip} />
      </div>
    </div>
  );
};

export default SellerCell;
